import api, { apiRequest } from './api';

export const surveyApiService = {
    // Question Types
    getQuestionTypes: () => apiRequest('/survey/types/'),

    // Surveys
    getSurveys: () => apiRequest('/survey/surveys/'),
    getSurveyDetail: (slug) => apiRequest(`/survey/surveys/${slug}/`),
    createSurvey: (data) => apiRequest('/survey/surveys/', 'POST', data),
    updateSurvey: (slug, data) => apiRequest(`/survey/surveys/${slug}/`, 'PATCH', data),
    deleteSurvey: (slug) => apiRequest(`/survey/surveys/${slug}/`, 'DELETE'),
    submitSurvey: (slug, data) => apiRequest(`/survey/surveys/${slug}/submit/`, 'POST', data),
    getSurveyAnalytics: (slug) => apiRequest(`/survey/surveys/${slug}/analytics/`),

    // Sections
    getSections: (surveyId) => apiRequest(`/survey/sections/?survey=${surveyId}`),
    createSection: (data) => apiRequest('/survey/sections/', 'POST', data),
    updateSection: (id, data) => apiRequest(`/survey/sections/${id}/`, 'PATCH', data),
    deleteSection: (id) => apiRequest(`/survey/sections/${id}/`, 'DELETE'),

    // Questions
    getQuestions: (surveyId) => apiRequest(`/survey/questions/?survey=${surveyId}`),
    createQuestion: (data) => apiRequest('/survey/questions/', 'POST', data),
    updateQuestion: (id, data) => apiRequest(`/survey/questions/${id}/`, 'PATCH', data),
    deleteQuestion: (id) => apiRequest(`/survey/questions/${id}/`, 'DELETE'),

    // Submissions
    getSubmissions: (surveySlug) => {
        const url = surveySlug ? `/survey/submissions/?survey=${surveySlug}` : '/survey/submissions/';
        return apiRequest(url);
    },
    getSubmissionDetail: (id) => apiRequest(`/survey/submissions/${id}/`),
};
